<template>
  <div id="app">
    <!-- 条件查询 -->
    <div class="titleContainer">
      <div class="conditionContainer">
        <el-select v-model="mapType" placeholder="请选择" class="select-input" size="small" @change="changeMapType">
          <el-option
            v-for="item in mapTypes"
            :key="item"
            :label="item"
            :value="item"
            >
          </el-option>
        </el-select>

        <el-select v-model="selectedCityName" placeholder="请选择" class="select-input" size="small" @change="selectCity">
          <el-option
            v-for="item in cityNameCheckOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>

        <el-checkbox-group v-model="baseCheckList" @change="baseCheckChange" class="checkbox-group">
          <el-checkbox
            v-for="item in baseCheckOptions"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-checkbox-group>

        <el-divider direction="vertical"></el-divider>
        
        <el-checkbox-group v-model="specialCheckList" @change="specialCheckChange" class="checkbox-group">
          <el-checkbox
            v-for="item in specialCheckOptions"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-checkbox-group>
      </div>

      <div>
        <el-button v-show="selectedCityName === '北京市'" type="success" plain @click="showDialog(0)" size="mini">旅游年卡</el-button>
        <el-button v-show="selectedCityName === '北京市'" type="success" plain @click="showDialog(1)" size="mini">北京预约</el-button>
        <el-button v-show="selectedCityName === '北京市'" type="success" plain @click="showDialog(2)" size="mini">4d电影</el-button>
      </div>
      
    </div>

    <!-- 移动端筛选栏（仅小屏显示） -->
    <div class="mobile-filter-bar">
      <div class="mobile-filter-info">
        <span>{{ selectedCityName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>{{ mapType }}</span>
      </div>
      <el-button type="primary" size="small" icon="el-icon-s-operation" @click="filterDialogVisible = true">筛选</el-button>
    </div>

    <!-- 移动端筛选弹窗 -->
    <el-dialog title="筛选条件" :visible.sync="filterDialogVisible" width="95%" top="3vh" class="mobile-filter-dialog" :append-to-body="true">
      <div class="mobile-filter-content">
        <div class="mobile-filter-item">
          <label>地图类型</label>
          <el-select v-model="mapType" placeholder="请选择" size="small" @change="changeMapType">
            <el-option
              v-for="item in mapTypes"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="mobile-filter-item">
          <label>城市</label>
          <el-select v-model="selectedCityName" placeholder="请选择" size="small" @change="selectCity">
            <el-option
              v-for="item in cityNameCheckOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="mobile-filter-item">
          <label>基础筛选</label>
          <el-checkbox-group v-model="baseCheckList" @change="baseCheckChange">
            <el-checkbox
              v-for="item in baseCheckOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-checkbox-group>
        </div>
        <div class="mobile-filter-item" v-if="specialCheckOptions.length > 0">
          <label>特殊筛选</label>
          <el-checkbox-group v-model="specialCheckList" @change="specialCheckChange">
            <el-checkbox
              v-for="item in specialCheckOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-checkbox-group>
        </div>
        <div class="mobile-filter-item" v-show="selectedCityName === '北京市'">
          <el-button type="success" plain @click="showDialog(0)" size="small">旅游年卡</el-button>
          <el-button type="success" plain @click="showDialog(1)" size="small">北京预约</el-button>
          <el-button type="success" plain @click="showDialog(2)" size="small">4d电影</el-button>
        </div>
      </div>
    </el-dialog>

    <GaodeContainer :defaultData='showData' :cityName='selectedCityName' ref='gaode' v-if="mapType === '高德'"></GaodeContainer>
    <BaiduContainer :defaultData='showData' :cityName='selectedCityName' ref='baidu' v-else-if="mapType === '百度'"></BaiduContainer>
    <TianContainer :defaultData='showData' :cityName='selectedCityName' ref='tian' v-else-if="mapType === '天地图'"></TianContainer>

    <el-dialog title="北京景点预约信息查询系统" :visible.sync="url1DialogVisible" width="90%" top="30px">
      <div style="padding-left: 20px; padding-right: 20px; max-width: 1400px; margin: 0 auto;">

        <div style="margin-bottom: 10px 0;">
          <el-select v-model="location" placeholder="请选择景点" filterable clearable >
            <el-option
              v-for="item in locations"
              :key="item"
              :label="item"
              :value="item"
              >
            </el-option>
          </el-select>
          <el-select v-model="queryDateType" placeholder="请选择" @change="calculateAvailableDate">
            <el-option
              v-for="item in queryDateTypes"
              :key="item"
              :label="item"
              :value="item"
              >
            </el-option>
          </el-select>
           <el-date-picker
            v-model="queryDate"
            type="date"
            value-format="yyyy-MM-dd"
            @change="calculateAvailableDate"
            placeholder="选择日期">
          </el-date-picker>
        </div>

        <!-- 表格 -->
        <el-table :data="scenicData.filter(data => !location || data.景点.includes(location))" 
        border style="width: 100%" max-height="500" :default-sort="{ prop: '景点' }">
          <el-table-column prop="景点" label="景点" width="130" align="center"></el-table-column>
          <el-table-column :label="earlyDateLabel" width="160" align="center">
            <template #default="scope">
              <el-tag v-for="(date, index) in scope.row.earlyDate" :key="index" size="small" type="success"
                style="margin-right: 4px">
                {{ date }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="lateDateLabel" width="160" align="center">
            <template #default="scope">
              <el-tag v-for="(date, index) in scope.row.lateDate" :key="index" size="small" type="success"
                style="margin-right: 4px">
                {{ date }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="预约时间" label="预约时间" width="120" align="center"></el-table-column>
          <el-table-column prop="门票价格" label="门票价格" width="170" align="center">
            <template #default="scope">
              <pre>{{ scope.row.门票价格 }}</pre>
            </template>
          </el-table-column>
          <el-table-column prop="备注" label="备注" min-width="220">
            <template #default="scope">
              <pre>{{ scope.row.备注 }}</pre>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog title="4D影院" :visible.sync="url2DialogVisible" width="90%">
      <div class="demo-image__lazy">
        <el-image :src="url2">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import allData from "@/data/all.js"
import BaiduContainer from './components/BaiduContainer.vue'
import GaodeContainer from './components/GaodeContainer.vue'
import TianContainer from './components/TianContainer.vue'

export default {
  name: 'App',
  components: {
    BaiduContainer,
    GaodeContainer,
    TianContainer,
  },
  data() {
    return {
      mapType: '高德',
      mapTypes: ['高德', '百度', '天地图'],
      queryDateTypes: ['预约时间', '参观时间'],
      queryDateType: '预约时间',
      queryDate: '',
      earlyDateLabel: '最早可参观日期',
      lateDateLabel: '最晚可参观日期',
      scenicData: [
        { 景点: "天安门广场", 预约规则: "1-7", 预约时间: "12:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "" },
        { 景点: "天安门城楼", 预约规则: "1-7", 预约时间: "17:00", earlyDate: [], lateDate:[], 门票价格: "15元/人", 免约人群: "无", 备注: "18周岁（不含）以下、60周岁（含）以上预约后免费" },
        { 景点: "故宫", 预约规则: "1-7", 预约时间: "20:00", earlyDate: [], lateDate:[], 门票价格: "4.1~10.31为60元/人\n其他40元/人", 免约人群: "无", 备注: "18周岁以上学生20元, 未满18周岁免费, 60岁以上免费" },
        { 景点: "国博", 预约规则: "1-7", 预约时间: "17:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "60周岁可走绿色通道进入" },
        { 景点: "人民大会堂", 预约规则: "1-2", 预约时间: "17:00", earlyDate: [], lateDate:[], 门票价格: "成人30元/人, \n学生15元/人", 免约人群: "无", 备注: "18周岁（不含）以下、60周岁（含）以上预约后免费" },
        { 景点: "毛主席纪念堂", 预约规则: "1-6", 预约时间: "12:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "" },
        { 景点: "天坛", 预约规则: "无", 预约时间: "21:00", earlyDate: [], lateDate:[], 门票价格: "门票15元/人\n联票34元/人", 免约人群: "无", 备注: "18周岁（不含）以下、60周岁（含）以上免费参观" },
        { 景点: "军事博物馆", 预约规则: "1-7", 预约时间: "8/17/20", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "", 备注: "6周岁以下、60岁以上免预约" },
        { 景点: "首都博物馆", 预约规则: "1-7", 预约时间: "10:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "" },
        { 景点: "自然博物馆", 预约规则: "1-3", 预约时间: "11:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "好像是可以在门口买票?" },
        { 景点: "中国科学技术馆", 预约规则: "1-7", 预约时间: "18:00", earlyDate: [], lateDate:[], 门票价格: "30元/人", 免约人群: "无", 备注: "儿童老人免门票" },
        { 景点: "雍和宫", 预约规则: "无", 预约时间: "无", earlyDate: [], lateDate:[], 门票价格: "成人30元/人\n老人儿童12元/人", 免约人群: "无", 备注: "" },
        { 景点: "颐和园", 预约规则: "1-7", 预约时间: "21:00", earlyDate: [], lateDate:[], 门票价格: "成人30元/人\n7~14岁15元/人", 免约人群: "无", 备注: "6周岁或者120cm以下、60周岁（含）以上免费参观" },
        { 景点: "北京大学", 预约规则: "1-7", 预约时间: "8:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "", 备注: "8周岁以下免预约" },
        { 景点: "清华大学", 预约规则: "1-2,1-8", 预约时间: "17:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "", 备注: "8周岁以下免预约" },
        { 景点: "考古博物馆", 预约规则: "1-3", 预约时间: "9:00", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "" },
        { 景点: "中国工艺美术馆", 预约规则: "1-14", 预约时间: "", earlyDate: [], lateDate:[], 门票价格: "0元/人", 免约人群: "无", 备注: "" }
      ],
      locations: [],
      location: '',
      url1DialogVisible: false,
      url2DialogVisible: false,
      url1: 'https://vc89.cn/1.png',
      url2: 'https://vc89.cn/2.png',
      cityNameCheckOptions: [],
      selectedCityName: '北京市',
      baseCheckOptions: [],
      baseCheckList: [],
      preBaseCheckList: [],
      specialCheckOptions: [],
      specialCheckList: [],
      showData: [],
      cityList: {},
      cityMap: {},
      filterDialogVisible: false
    };
  },
  created() {
    this.cityNameCheckOptions.push("全部")
    for(const data of allData) {
        this.cityNameCheckOptions.push(data.name)
        this.cityMap[data.name] = data
    }
    console.log('cityMap', this.cityMap)
  },
  mounted() {
    this.scenicData.sort((a, b) => a.景点.length - b.景点.length);
    this.locations = this.scenicData.map(e => e.景点)
    this.queryDate = this.formatDate(new Date())
    this.selectCity(this.selectedCityName)
  },
  watch: {
    url1DialogVisible(val) {
      if(val === false) {
        return
      }
      for (let item of this.scenicData) {
        this.$set(item, 'earlyDate', []);
        this.$set(item, 'lateDate', []);
      }
      this.calculateAvailableDate()
      this.location = ''
    }
  },
  methods: {
    selectCity(cityName) {
      this.baseCheckOptions.splice(0)
      this.baseCheckList.splice(0)
      this.specialCheckOptions.splice(0)
      this.specialCheckList.splice(0)
      this.preBaseCheckList.splice(0)
      
      var cityList = []
      if ('全部' === cityName) {
        // 遍历 cityMap 中的所有城市数据，收集所有的 city 数组并合并
        cityList = Object.values(this.cityMap)
            .flatMap(entry => (entry.city || []).map(cat => ({ ...cat, _type: entry.type })));
      } else {
        var cityData = this.cityMap[cityName];
        cityList = cityData ? (cityData.city || []).map(cat => ({ ...cat, _type: cityData.type })) : [];
      }
      console.log('选择城市', cityName, cityList)
      for(const data of cityList) {
        if(data.group === 'base') {
          this.baseCheckOptions.push(data.name)
          if(data.show === true) {
            this.baseCheckList.push(data.name)
          }
        } else {
          this.specialCheckOptions.push(data.name)
        }
      }

      this.cityList = cityList
      console.log('选择城市结果', cityName, this.baseCheckOptions, this.baseCheckList, this.cityList)
      this.baseCheckChange(this.baseCheckList)
    },
    // 选中事件
    baseCheckChange(valueArray) {
      this.specialCheckList = []
      this.preBaseCheckList = []
      var showList = this.cityList.filter(e => this.baseCheckList.includes(e.name))
      console.log('showList', this.selectedCityName, valueArray, showList, this.baseCheckList)

      var showData = []
      for (const data of showList) {
        if(data.group !== 'base') {
          continue
        }
        for (const item of data.list) {
          item.push(data.color, data._type || 'BD-09')
          showData.push(item)
        }
      }
      this.showData = showData
      console.log('showData', this.selectedCityName, showData)
      // 将选好的数据添加到图层上
      if (this.mapType === '高德') {
        this.$refs.gaode.addOverlay(showData);
      } else if (this.mapType === '百度') {
        this.$refs.baidu.addOverlay(showData);
      } else if (this.mapType === '天地图') {
        this.$refs.tian.addOverlay(showData);
      }
    },
    specialCheckChange(valueArray) {
      if(valueArray.length === 0) {
        this.baseCheckList = this.preBaseCheckList
        this.baseCheckChange(valueArray)
        return
      } else {
        this.preBaseCheckList = this.baseCheckList
        this.baseCheckList = []
      }

      var specialList = this.cityList.filter(e => valueArray.includes(e.name))
      const showList = specialList[0].list
      console.log('showList111111111111', showList)
      var showData = []
      for (const data of this.cityList) {
         if(data.group !== 'base') {
          continue
        }
        for (const item of data.list) {
          if(!showList.includes(item[2])) {
            continue
          }
          item.push(data.color, data._type || 'BD-09')
          showData.push(item)
        }
      }
      console.log('showData', this.selectedCityName, showList, showData)
      // 将选好的数据添加到图层上
      if (this.mapType === '高德') {
        this.$refs.gaode.addOverlay(showData);
      } else if (this.mapType === '百度') {
        this.$refs.baidu.addOverlay(showData);
      } else if (this.mapType === '天地图') {
        this.$refs.tian.addOverlay(showData);
      }
    },
    changeMapType(value) {
      this.mapType = value
    },
    showDialog(type) {
      if (type === 0) {
        window.open('https://vc89.cn/nianka.xlsx', '_blank');
      }
      if (type === 1) {
        this.url1DialogVisible = true
      }
      if (type === 2) {
        this.url2DialogVisible = true
      }
    },
    // 计算最早可预约日期（核心逻辑）
    calculateAvailableDate() {
      if(this.queryDateType === '预约时间') {
        this.earlyDateLabel = '最早可参观日期'
        this.lateDateLabel = '最晚可参观日期'
      } else {
        this.earlyDateLabel = '最早可预约日期'
        this.lateDateLabel = '最晚可预约日期'
      }

      console.log('calculateAvailableDate before', this.queryDate, this.queryDateType, this.scenicData);
      for (let item of this.scenicData) {
        this.parseToTwoArrays(item)
      }
      console.log('calculateAvailableDate after', this.queryDate, this.queryDateType, this.scenicData);
    },
    parseToTwoArrays(item) {
      this.$set(item, 'earlyDate', []);
      this.$set(item, 'lateDate', []);

      // 解析查询日期
      const baseDate = this.parseDate(this.queryDate);

      const earlyDate = []
      const lateDate = []
      if (item.预约规则 === '无') {
        earlyDate.push('无需预约');
        lateDate.push('无需预约');
      } else {
         // 分割规则
        const parts = item.预约规则.split(',').map(part => part.trim());
        for (const part of parts) {
          const match = part.match(/^(\d+)-(\d+)$/);
          if (!match) {
            console.warn(`无效格式: ${part}`);
            continue;
          }

          const minDays = parseInt(match[1], 10); // x in x-y
          const maxDays = parseInt(match[2], 10); // y in x-y
          
          const cleanBaseDate = new Date(baseDate);
          const earliest = new Date(cleanBaseDate);
          const latest = new Date(cleanBaseDate);
          if(this.queryDateType === '预约时间') {
            // 计算最早可参观日期（当前 + minDays 天）
            earliest.setDate(cleanBaseDate.getDate() + minDays);
            // 计算最晚可参观日期（当前 + maxDays 天）
            latest.setDate(cleanBaseDate.getDate() + maxDays);
          } else {
            // 计算最早可预约日期（当前 - maxDays 天）
            earliest.setDate(cleanBaseDate.getDate() - maxDays);
            // 计算最晚可预约日期（当前 - minDays 天）
            latest.setDate(cleanBaseDate.getDate() - minDays);
          }

          // 格式化为 YYYY-MM-DD 字符串并推入数组
          earlyDate.push(this.formatDate(earliest));
          lateDate.push(this.formatDate(latest));
        }
      }
      this.$set(item, 'earlyDate', earlyDate);
      this.$set(item, 'lateDate', lateDate);
    },
    // 日期格式化辅助函数
    formatDate(date) {
      try {
        if(date === null || date === undefined) {
          console.error('date 是空的')
          return
        }
        if (typeof date === 'string') {
          console.error('date 是字符串直接返回')
          return date
        }
        if(!(date instanceof Date)) {
          console.error('date 不是Date类型')
          return
        }
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      } catch(err) {
        console.error('formatDate错误 ', date, err)
        return ''
      }
    },
    // 将 YYYY-MM-DD 字符串转为 Date 对象
    parseDate(str) {
       if (!(typeof str === 'string')) {
          return str
        }
      try {
        const [y, m, d] = str.split('-').map(Number);
        return new Date(y, m - 1, d);
      } catch(err) {
        console.error('parseDate错误 ', str, err)
        return ''
      }
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
}

.titleContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.conditionContainer {
  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直居中 */
  gap: 12px; /* 元素间距 */
  flex-wrap: nowrap; /* 禁止换行 */
}

.checkbox-group {
  flex: 1; /* 占据剩余空间（可选） */
  white-space: nowrap; /* 防止 checkbox 内部换行 */
}

.select-input {
  width: 100px; /* 固定宽度，避免过宽 */
}

h3 {
  margin-bottom: 16px;
  color: #333;
}

pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: inherit;
  font-size: 14px;
}

.el-table .cell {
  line-height: 1.5;
}

/* 移动端筛选栏 - 默认隐藏 */
.mobile-filter-bar {
  display: none;
}

/* 移动端筛选弹窗内容 */
.mobile-filter-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 4px;
}

.mobile-filter-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-filter-item label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

@media (max-width: 1024px) {
  #app {
    margin-top: 0;
  }

  .titleContainer {
    display: none !important;
  }

  .mobile-filter-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 12px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .mobile-filter-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #303133;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  #container {
    height: calc(100vh - 40px) !important;
  }
}
</style>
